import moment from 'moment';

import request from './request';
import PushHistory from "./PushHistory";
import { getSystemSettings, setSessionId, setSelectedPromocode, setCustomerToken, getSessionId } from './SettingsRetriever';
import { setCookie, deleteCookie } from './CookiesRetriever';

import { emptyCart } from '../services/cart';

export default (username, password, channel, successCallback, errorCallback) => {
    if (getSystemSettings().b2b && getSystemSettings().b2b.is_private === false) {
        request({
            url: getSystemSettings().api + '/inntopia/travel-agent/login',
            method: 'POST',
            data: {
                sessionId: getSessionId(),
                salesId: channel.inntopiaChannelSalesId,
                email: username,
                password: password
            }
        })
        .then( (data) => {
            if(data.status === 200){
                const d = moment.utc().add(1, 'days').toDate();
                let readOnly = false;
                if(channel && channel.channel && channel.channel.readOnly) {
                    readOnly = channel.channel.readOnly;
                }
                const cookieData = {
                    id: data.data.travelAgentId,
                    channel: channel.inntopiaChannelSalesId,
                    token: data.data.token,
                    paymentMethods: channel.channelData.paymentMethods,
                    hideTopbarSwitch: channel.channelData.hideTopbarSwitch,
                    readOnlyMode: readOnly,
                    authDetails: {
                        user: username,
                        password: password
                    }
                };
                setCookie('b2b', JSON.stringify(cookieData), d);
                PushHistory("/shopping-cart/review");
            }else{
                errorCallback(data);
            }
        });
    } else {
        emptyCart();
        request({
            url: getSystemSettings().api + '/inntopia/session?salesid=' + channel.inntopiaChannelSalesId,
            method: 'GET'
        })
        .then( (result) => {
            setSelectedPromocode(null);
            setCustomerToken(null);
            deleteCookie('b2b');
            deleteCookie('b2bagent');
            deleteCookie('b2bchannel');
            setSessionId(result.data.SessionId);
    
            request({
                url: getSystemSettings().api + '/inntopia/travel-agent/login',
                method: 'POST',
                data: {
                    sessionId: result.data.SessionId,
                    salesId: channel.inntopiaChannelSalesId,
                    email: username,
                    password: password
                }
            })
            .then( (data) => {
                if(data.status === 200){
                    const d = moment.utc().add(1, 'days').toDate();
                    let readOnly = false;
                    if(channel && channel.channel && channel.channel.readOnly) {
                        readOnly = channel.channel.readOnly;
                    }
                    const cookieData = {
                        id: data.data.travelAgentId,
                        channel: channel.inntopiaChannelSalesId,
                        token: data.data.token,
                        paymentMethods: channel.channelData.paymentMethods,
                        hideTopbarSwitch: channel.channelData.hideTopbarSwitch,
                        readOnlyMode: readOnly,
                        authDetails: {
                            user: username,
                            password: password
                        }
                    };
                    setCookie('b2b', JSON.stringify(cookieData), d);
                    successCallback(cookieData);
                }else{
                    errorCallback(data);
                }
            });
        });
    }
}
